import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.config.devtools = true

export const store = new Vuex.Store({
    state: {
        userID: '',
        staffID: '',
        studentID: '',
        firstName: '',
        lastName: '',
        studentName: '',
        count: 0,
        classesDashboardSingleID: '',
        classesDashboardSingleName: '',
        viewKelasID: '',
        positiveBehaviorID: '',
        positiveBehaviorName: '',
        positivePeriod: 0,
        positivePeriodYear: 0,
        viewStaffAttendance: 0,
        viewStudentAttendance: 0,
        viewStudentAttendanceStatus: 1,
        studentAttendanceKelasID:'',
        studentAttendanceKelasName:'',
        viewGroupID:'',
        viewGroupName:'',
        teacherID: '',
        teacherName: '',
        durationMonth: 0,
        duration: 0,
        formId: '',
        formName: '',
        formStatus: 1,
        formFields: '',
        // groupDashboardSingleID: '',
        // groupDashboardSingleName: '',
        superViewSchoolID: '',
        superViewSchoolName: '',
        superViewPlanChangeRequestID: '',
        superViewPlanChangeRequestSchoolName: '',
        superViewTemplateID: '',
        viewSubmissionsBehaviorID: '',
        viewSubmissionsBehaviorName: '',
        viewSubmissionsCategory: '',
        viewSubmissionsDuration: '',
        viewSubmissionsDurationDaily: '',
        viewSubmissionsDurationMonthly: '',
        viewSubmissionsDurationYearly: '',
        viewSubmissionsAttendanceType: '',
        startDate: "",
        endDate: "",
        year: "",
        actionDate: ""

    },
    getters:{
        getUserID: state => {
            console.log("16 getUserID: " + state.userID)
            return state.userID;
        },        
        getStaffID: state => {
            console.log("20 getStaffID: " + state.staffID)
            return state.staffID;
        },        
        getStudentID: state => {
            console.log("getStudentID: " + state.studentID)
            return state.studentID;
        },
        getName: state => {
            console.log("24 getName: " + state.firstName + " " + state.lastName)
            return state.firstName + " " + state.lastName;
        },    
        getStudentName: state => {
            console.log("getStudentName: " + state.studentName)
            return state.studentName;
        },
        getClassesDashboardSingleID: state => {
            return state.classesDashboardSingleID;
        },
        getClassesDashboardSingleName: state => {
            return state.classesDashboardSingleName;
        },
        getPositiveBehaviorID: state => {
            return state.positiveBehaviorID;
        },
        getPositiveBehaviorName: state => {
            return state.positiveBehaviorName;
        },
        getPositivePeriod: state => {
            return state.positivePeriod;
        },
        getPositivePeriodYear: state => {
            return state.positivePeriodYear;
        },
        getViewStaffAttendance: state => {
            return state.viewStaffAttendance;
        },
        getViewStudentAttendance: state => {
            return state.viewStudentAttendance;
        },
        getViewStudentAttendanceStatus: state => {
            return state.viewStudentAttendanceStatus;
        },
        getStudentAttendanceKelasID: state => {
            return state.studentAttendanceKelasID;
        },
        getStudentAttendanceKelasName: state => {
            return state.studentAttendanceKelasName;
        },
        getViewKelasID: state => {
            return state.viewKelasID;
        },
        getViewGroupID: state => {
            return state.viewGroupID;
        },
        getViewGroupName: state => {
            return state.viewGroupName;
        },     
        getTeacherID: state => {
            return state.teacherID;
        },    
        getTeacherName: state => {
            return state.teacherName;
        },
        getDurationMonth: state => {
            return state.durationMonth;
        },
        getDuration: state => {
            return state.duration;
        },
        getFormId: state => {
            return state.formId;
        },
        getFormName: state => {
            return state.formName;
        },
        getFormStatus: state => {
            return state.formStatus;
        },
        getFormFields: state => {
            return state.formFields;
        },
        // getGroupDashboardSingleID: state => {
        //     return state.groupDashboardSingleID;
        // },
        // getGroupDashboardSingleName: state => {
        //     return state.groupDashboardSingleName;
        // }, 
        getSuperViewSchoolID: state => {
            return state.superViewSchoolID;
        },
        getSuperViewSchoolName: state => {
            return state.superViewSchoolName;
        },
        getSuperViewPlanChangeRequestID: state => {
            return state.superViewPlanChangeRequestID;
        },
        getSuperViewPlanChangeRequestSchoolName: state => {
            return state.superViewPlanChangeRequestSchoolName;
        },
        getSuperViewTemplateID: state => {
            return state.superViewTemplateID;
        },
        getViewSubmissionsBehaviorID: state => {
            return state.viewSubmissionsBehaviorID;
        },
        getViewSubmissionsBehaviorName: state => {
            return state.viewSubmissionsBehaviorName;
        },
        getViewSubmissionsCategory: state => {
            return state.viewSubmissionsCategory;
        },
        getViewSubmissionsDuration: state => {
            return state.viewSubmissionsDuration;
        },
        getViewSubmissionsDurationDaily: state => {
            return state.viewSubmissionsDurationDaily;
        },
        getViewSubmissionsDurationMonthly: state => {
            return state.viewSubmissionsDurationMonthly;
        },
        getViewSubmissionsDurationYearly: state => {
            return state.viewSubmissionsDurationYearly;
        },
        getViewSubmissionsAttendanceType: state => {
            return state.viewSubmissionsAttendanceType;
        },
        getStartDate: state => {
            return state.startDate;
        },
        getEndDate: state => {
            return state.endDate;
        },
        getYear: state => {
            return state.year;
        },
        getActionDate: state => {
            return state.actionDate;
        },
    },
    mutations: {
        UPDATE_USERID: (state,value) => {
            state.userID = value
        },
        UPDATE_STAFF_ID: (state,value) => {
            state.staffID = value
        },
        UPDATE_FIRSTNAME: (state,value) => {
            state.firstName = value
        },
        UPDATE_LASTNAME: (state,value) => {
            state.lastName = value
        },
        UPDATE_CLASSES_DASHBOARD_SINGLE_ID: (state,value) => {
            state.classesDashboardSingleID = value
        },
        UPDATE_CLASSES_DASHBOARD_SINGLE_NAME: (state,value) => {
            state.classesDashboardSingleName = value
        },
        UPDATE_STUDENT_ID: (state,value) => {
            state.studentID = value
        },
        UPDATE_STUDENT_NAME: (state,value) => {
            state.studentName = value
        },
        UPDATE_POSITIVE_BEHAVIOR_ID: (state,value) => {
            state.positiveBehaviorID = value
        },
        UPDATE_POSITIVE_BEHAVIOR_NAME: (state,value) => {
            state.positiveBehaviorName = value
        },
        UPDATE_POSITIVE_PERIOD: (state,value) => {
            state.positivePeriod = value
        },
        UPDATE_POSITIVE_PERIOD_YEAR: (state,value) => {
            state.positivePeriodYear = value
        },
        UPDATE_VIEW_STAFF_ATTENDANCE: (state,value) => {
            state.viewStaffAttendance = value
        },
        UPDATE_VIEW_STUDENT_ATTENDANCE: (state,value) => {
            state.viewStudentAttendance = value
        },
        UPDATE_VIEW_STUDENT_ATTENDANCE_STATUS: (state,value) => {
            state.viewStudentAttendanceStatus = value
        },
        UPDATE_STUDENT_ATTENDANCE_KELAS_ID: (state,value) => {
            state.studentAttendanceKelasID = value
        },
        UPDATE_STUDENT_ATTENDANCE_KELAS_NAME: (state,value) => {
            state.studentAttendanceKelasName = value
        },
        UPDATE_VIEW_KELAS_ID: (state,value) => {
            state.viewKelasID = value
        },
        UPDATE_VIEW_GROUP_ID: (state,value) => {
            state.viewGroupID = value
        },
        UPDATE_VIEW_GROUP_NAME: (state,value) => {
            state.viewGroupName = value
        },
        UPDATE_TEACHER_ID: (state,value) => {
            state.studentID = value
        },
        UPDATE_TEACHER_NAME: (state,value) => {
            state.studentName = value
        },
        UPDATE_DURATION_MONTH: (state,value) => {
            state.durationMonth = value
        },
        UPDATE_DURATION: (state,value) => {
            state.duration = value
        }, 
        UPDATE_FORM_ID: (state,value) => {
            state.formId = value
        },
        UPDATE_FORM_NAME: (state,value) => {
            state.formName = value
        },
        UPDATE_FORM_STATUS: (state,value) => {
            state.formStatus = value
        },
        UPDATE_FORM_FIELDS: (state,value) => {
            state.formFields = value
        },
        // UPDATE_GROUP_DASHBOARD_SINGLE_ID: (state,value) => {
        //     state.groupDashboardSingleID = value
        // },
        // UPDATE_GROUP_DASHBOARD_SINGLE_NAME: (state,value) => {
        //     state.groupDashboardSingleName = value
        // },
        SUPER_UPDATE_VIEW_SCHOOL_ID: (state,value) => {
            state.superViewSchoolID = value
        },
        SUPER_UPDATE_VIEW_SCHOOL_NAME: (state,value) => {
            state.superViewSchoolName = value
        },
        SUPER_UPDATE_VIEW_PLAN_CHANGE_REQUEST_ID: (state,value) => {
            state.superViewPlanChangeRequestID = value
        },
        SUPER_UPDATE_VIEW_PLAN_CHANGE_REQUEST_SCHOOL_NAME: (state,value) => {
            state.superViewPlanChangeRequestSchoolName = value
        },
        SUPER_VIEW_TEMPLATE_ID: (state,value) => {
            state.superViewTemplateID = value
        },
        UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_ID: (state,value) => {
            state.viewSubmissionsBehaviorID = value
        },
        UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_NAME: (state,value) => {
            state.viewSubmissionsBehaviorName = value
        },
        UPDATE_VIEW_SUBMISSIONS_CATEGORY: (state,value) => {
            state.viewSubmissionsCategory = value
        },
        UPDATE_VIEW_SUBMISSIONS_DURATION: (state,value) => {
            state.viewSubmissionsDuration = value
        },
        UPDATE_VIEW_SUBMISSIONS_DURATION_DAILY: (state,value) => {
            state.viewSubmissionsDurationDaily = value
        },
        UPDATE_VIEW_SUBMISSIONS_DURATION_MONTHLY: (state,value) => {
            state.viewSubmissionsDurationMonthly = value
        },
        UPDATE_VIEW_SUBMISSIONS_DURATION_YEARLY: (state,value) => {
            state.viewSubmissionsDurationYearly = value
        },        
        UPDATE_VIEW_SUBMISSIONS_ATTENDANCE_TYPE: (state,value) => {
            state.viewSubmissionsAttendanceType = value
        },
        UPDATE_START_DATE: (state,value) => {
            state.startDate = value
        },
        UPDATE_END_DATE: (state,value) => {
            state.endDate = value
        },
        UPDATE_YEAR: (state,value) => {
            state.year = value
        },
        UPDATE_ACTION_DATE: (state,value) => {
            state.actionDate = value
        },
    },
    actions: {
        //mutations have to be synchronous. action don't - means it can be async. https://vuex.vuejs.org/guide/actions.html
        update_staff_ID: (context, payload) => {
            context.commit("UPDATE_STAFF_ID", payload)
        },
        // toggleTodo: (context, payload) => {
        //     context.commit("TOGGLE_TODO", payload)
        // },
        // deleteTodo: (context, payload) => {
        //     context.commit("DELETE_TODO", payload)
        // }
    }
  })


// WEBPACK FOOTER //
// ./src/store.js